import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelCheckbox as _vModelCheckbox, toDisplayString as _toDisplayString, createBlock as _createBlock, withModifiers as _withModifiers, withCtx as _withCtx, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-363c62c0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vue-tl-tlbs-alumni-renewal-component" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<section data-v-363c62c0><div class=\"pullout\" data-v-363c62c0><h4 data-v-363c62c0> Your decision to be part of the Thought Leaders — whether it be as a new student in The Curriculum, a full student of The School or as a Black Belt member of Faculty — is a decision to be committed. </h4></div><div class=\"content-cols\" data-v-363c62c0><div class=\"col\" data-v-363c62c0><p data-v-363c62c0>Our philosophy is that we commit to the committed. We suggest that all thought leaders use that as a heuristic for running their enterprises in a commercially conscious manner. As such this agreement and the principles are educational as much as they are contractual.</p><p data-v-363c62c0>At its highest level, we commit to bringing you world class, accessible education. Education designed to help you run a commercially successful thought leader&#39;s practice. For your part you commit each quarter to work diligently to apply the methodology, to play the game, grow professionally and personally, and increase your practice revenue.</p></div><div class=\"col\" data-v-363c62c0><p data-v-363c62c0>Your initial commitment financially is for one year, paid monthly in advance and you will give one quarter&#39;s notice if you wish to leave. Some people come for a reason, some for a season and some for a lifetime but each of us make commitment pledges along the way.</p><p data-v-363c62c0>Your pledge for each program is:</p><p data-v-363c62c0><strong data-v-363c62c0>The Curriculum</strong>: I am committed to learning the curriculum in less than six months.<br data-v-363c62c0><strong data-v-363c62c0>The Curriculum Accelerator</strong>: I will prepare myself for The School in one quarter or less.<br data-v-363c62c0><strong data-v-363c62c0>The School</strong>: I will work diligently to apply the methodology and increase my practice revenue.<br data-v-363c62c0></p></div></div></section><hr data-v-363c62c0>", 2)
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<hr data-v-363c62c0><section data-v-363c62c0><p data-v-363c62c0>So that things are super clean we would like you to be across some finer points so that you understand the following. </p><p data-v-363c62c0>I understand:</p><div class=\"content-cols\" data-v-363c62c0><div class=\"col\" data-v-363c62c0><h5 data-v-363c62c0> Cancellation </h5><ul data-v-363c62c0><li data-v-363c62c0>I can cancel my monthly enrolment fee in The School at any time with 3 month&#39;s notice to Thought Leaders. </li><li data-v-363c62c0>Monthly or annual enrolment cannot be deferred or suspended.</li><li data-v-363c62c0>All fees are non-refundable, non-transferable, and cannot be used as credit or to redeem other services or events.</li></ul><h5 data-v-363c62c0> Prerequisites </h5><p data-v-363c62c0><strong data-v-363c62c0>The Curriculum</strong>: None</p><p data-v-363c62c0><strong data-v-363c62c0>The School</strong>: The Curriculum</p><p data-v-363c62c0><strong data-v-363c62c0>The Program</strong>: Green Belt</p><p data-v-363c62c0><strong data-v-363c62c0>Faculty</strong>: Black Belt</p></div><div class=\"col\" data-v-363c62c0><h5 data-v-363c62c0> Photography </h5><p data-v-363c62c0>Some sessions will be recorded, videoed and/or photographed, and these videos and images are made available to other students via Thought Leaders Central. Videos and images may also be used for brochures and websites (like the images on thoughtleaders.com.au).</p><h5 data-v-363c62c0> Bringing my team </h5><p data-v-363c62c0>I can register my practice manager to observe any of the virtual immersions with compliments of Thought Leaders.</p></div></div></section><hr data-v-363c62c0><section data-v-363c62c0><h2 data-v-363c62c0> Payment Details </h2><p data-v-363c62c0>The School costs AUD $1500* per month. Upon confirmation you will be charged a pro-rated deposit - listed under &quot;Pay now&quot; below - which will cover you until the end of this month. This payment is non-refundable.</p><p data-v-363c62c0>Starting on the 1st of next month you will be charged AUD $1500* per month.</p><p data-v-363c62c0>* +GST for Australian residents.</p></section><hr data-v-363c62c0>", 5)
const _hoisted_9 = { class: "agreement" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, " Rejoin The School ", -1 /* HOISTED */))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1 /* HOISTED */))
const _hoisted_12 = {
  key: 0,
  class: "joined"
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "Welcome back to The School!", -1 /* HOISTED */))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "In the next five minutes you'll get an email confirming your re-enrolment with your program information and a copy of your signed Commitment Agreement.", -1 /* HOISTED */))
const _hoisted_15 = ["href"]
const _hoisted_16 = {
  key: 1,
  class: "content-cols"
}
const _hoisted_17 = { class: "col" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Your details", -1 /* HOISTED */))
const _hoisted_19 = { class: "content-cols" }
const _hoisted_20 = { class: "col" }
const _hoisted_21 = { class: "input-wrapper" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Full name", -1 /* HOISTED */))
const _hoisted_23 = { class: "col" }
const _hoisted_24 = { class: "input-wrapper" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "name" }, "Email", -1 /* HOISTED */))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1 /* HOISTED */))
const _hoisted_27 = { class: "accepted-terms" }
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Terms & Conditions", -1 /* HOISTED */))
const _hoisted_29 = {
  for: "accepted-terms",
  class: "input-checkbox"
}
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " ", -1 /* HOISTED */))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Your Signature", -1 /* HOISTED */))
const _hoisted_32 = { class: "col" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "Pay Now", -1 /* HOISTED */))
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, "$0.00**", -1 /* HOISTED */))
const _hoisted_37 = [
  _hoisted_36
]
const _hoisted_38 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "then", -1 /* HOISTED */))
const _hoisted_39 = ["disabled"]
const _hoisted_40 = { key: 0 }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_HeroImageComponent = _resolveComponent("HeroImageComponent")!
  const _component_TlbsInformationComponent = _resolveComponent("TlbsInformationComponent")!
  const _component_SignatureComponent = _resolveComponent("SignatureComponent")!
  const _component_PriceComponent = _resolveComponent("PriceComponent")!
  const _component_CardComponent = _resolveComponent("CardComponent")!
  const _component_SidebarComponent = _resolveComponent("SidebarComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_HeroImageComponent, {
      "sub-title": "The School",
      title: "Commitment Agreement"
    }),
    _hoisted_2,
    _createVNode(_component_TlbsInformationComponent),
    _hoisted_4,
    _createElementVNode("section", _hoisted_9, [
      _hoisted_10,
      _hoisted_11,
      (_ctx.joined)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            _hoisted_13,
            _hoisted_14,
            _createElementVNode("p", null, [
              _createTextVNode("There will be a link in the email to log you in, or if you remember your credentials you can go to the "),
              _createElementVNode("a", {
                href: `https://${_ctx.tlcDomain}/login`
              }, "login page", 8 /* PROPS */, _hoisted_15),
              _createTextVNode(" now.")
            ])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _hoisted_18,
              _createElementVNode("div", _hoisted_19, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.name) = $event)),
                      type: "text",
                      for: "name"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.name]
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_23, [
                  _createElementVNode("div", _hoisted_24, [
                    _hoisted_25,
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.email) = $event)),
                      type: "email",
                      for: "email"
                    }, null, 512 /* NEED_PATCH */), [
                      [_vModelText, _ctx.email]
                    ])
                  ])
                ])
              ]),
              _hoisted_26,
              _createElementVNode("div", _hoisted_27, [
                _hoisted_28,
                _createElementVNode("label", _hoisted_29, [
                  _withDirectives(_createElementVNode("input", {
                    id: "accepted-terms",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.acceptedTerms) = $event)),
                    type: "checkbox"
                  }, null, 512 /* NEED_PATCH */), [
                    [_vModelCheckbox, _ctx.acceptedTerms]
                  ]),
                  _createTextVNode(" I agree to the terms and conditions above ")
                ])
              ]),
              _hoisted_30,
              _hoisted_31,
              _createVNode(_component_SignatureComponent, { onChange: _ctx.signatureChanged }, null, 8 /* PROPS */, ["onChange"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_SidebarComponent, null, {
                default: _withCtx(() => [
                  _hoisted_33,
                  (_ctx.hasProRatedCharge)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_34, [
                        _createVNode(_component_PriceComponent, { cents: _ctx.prorated }, null, 8 /* PROPS */, ["cents"])
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_35, _hoisted_37)),
                  _hoisted_38,
                  _createElementVNode("p", null, _toDisplayString(_ctx.formatCents(_ctx.total)) + "* per month, starting 1st " + _toDisplayString(_ctx.nowMonth) + ".", 1 /* TEXT */),
                  (_ctx.chargebeeLoaded)
                    ? (_openBlock(), _createBlock(_component_CardComponent, {
                        key: 2,
                        ref: "card",
                        class: "cb-card fieldset field",
                        currency: 'AUD',
                        fonts: _ctx.cbCard.fonts,
                        styles: _ctx.cbCard.styles,
                        placeholder: _ctx.cbCard.placeholder,
                        locale: _ctx.cbCard.locale,
                        onChange: _ctx.cbCardChanged
                      }, null, 8 /* PROPS */, ["fonts", "styles", "placeholder", "locale", "onChange"]))
                    : _createCommentVNode("v-if", true),
                  _createElementVNode("div", null, [
                    _createElementVNode("button", {
                      class: "btn",
                      disabled: !_ctx.canSubmit,
                      onClick: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)), ["prevent"]))
                    }, " Join The School ", 8 /* PROPS */, _hoisted_39)
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("small", null, [
                      _createTextVNode(" *AUD +GST where applicable "),
                      (!_ctx.hasProRatedCharge)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_40, [
                            _hoisted_41,
                            _createTextVNode("**No pro-rated amount for end of month. ")
                          ]))
                        : _createCommentVNode("v-if", true)
                    ])
                  ])
                ]),
                _: 1 /* STABLE */
              })
            ])
          ])),
      _createVNode(_component_LoadingComponent, {
        loading: _ctx.loading,
        "outer-border": true
      }, null, 8 /* PROPS */, ["loading"])
    ])
  ]))
}